<template>
  <div class="permissoes">
    <v-card class="mt-3">
      <div class="pa-3" style="font-size: 16px">
        <div><strong>Código:</strong> {{ form.identificadortela }}</div>
        <div><strong>Tela:</strong> {{ form.descricaotela }}</div>
        <div><strong>Grupo:</strong> {{ form.grupo.descricaotelagrupo }}</div>
      </div>
    </v-card>
    <div class="mt-2">
      <v-btn icon to="/atena/tela">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>
    <v-card class="pa-3 mt-2">
      <Select label="Perfil" :options="optionsPerfil" v-model="perfilSelected" :disabled="loading" @input="buscarPermissoesPerfil"/>

      <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" dark class="mb-3">
        <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
        <div v-if="msgArrayError.length > 0">
          <ul v-for="error of msgArrayError" :key="error.key">
            <li>{{ error }}</li>
          </ul>
        </div>
      </v-alert>

      <Validator v-if="funcoes.length > 0" label="Funções da Tela" block>
        <div v-for="funcao in funcoes" :key="funcao.identificadorfuncaotela" style="flex: 100%" >
          <CheckBox
            v-model="funcao.status"
            :label="funcao.descricaofuncao"
            :disabled="loading"
            @input="onSubmit(funcao)"/>
        </div>
      </Validator>
        <th colspan="2">
           <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <!-- <span>Efetuar Frequência</span> -->
                <v-icon v-bind="attrs" v-on="on" size="20" >notification_important</v-icon>
              </template>
              <span class="text-caption white--text">A função "Alterar dados de anos anteriores "
              não deve ser aplicada ao perfil do professor,<br>
              pois esse tem o direito de alterar o diário em qualquer ano desde
              que tenha uma abertura extemporânea. </span>
            </v-tooltip>
       </th>
    </v-card>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, integer } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const AtenaTelaRepository = RepositoryFactory.get('atenaTela');
const AtenaPerfilRepository = RepositoryFactory.get('atenaPerfil');



export default {
  name: 'Permissoes',
  props: {
    id: [Number, String],
  },
  data() {
    return {
      loading: false,
      optionsPerfil: [],
      perfilSelected: '',
      form: {
        grupo: {},
        tela_funcoes: [],
      },
      funcoes: [],
      snackbar: false,
      submitText: '',
      msgArrayError: [],
    };
  },
  async beforeRouteEnter(to, from, next) {
    try{
      const perfis = await AtenaPerfilRepository.getPerfis();
      const tela = await AtenaTelaRepository.getTela(to.params.id);

      next(vm => {
        vm.montarPerfil(perfis.data.results);
        vm.load(tela.data.results);
      });
    }
    catch(e){
      next('/atena/tela');
    }
  },
  validations: {
    perfilSelected: { required, integer },
    funcoes: {
      required,
      $each: {
        identificadorfuncaotela: { required, integer },
      },
    }
  },
  methods: {
    montarPerfil(perfis) {
      this.optionsPerfil = perfis.map(key => ({ value: key.identificadorperfil, text: key.nomeperfil }));
      if(this.optionsPerfil.length > 0) {
        this.perfilSelected = this.optionsPerfil[0].value;
      }
    },
    load(data) {
      this.form = { ...data };

      if(this.form.tela_funcoes.length > 0) {
        this.funcoes = this.form.tela_funcoes.map(key => ({
          identificadorfuncaotela: key.identificadorfuncaotela,
          descricaofuncao: key.descricaofuncao,
          status: false,
        }));
      }

      this.buscarPermissoesPerfil();
      this.$Progress.finish();
    },
    async buscarPermissoesPerfil() {
      this.msgArrayError = [];
      if(this.form.tela_funcoes.length <= 0) { return; }

      try {
        this.loading = true;
        this.$Progress.start();
        for(const funcao of this.funcoes) {
          funcao.status = false;
        }

        const { data } = await AtenaTelaRepository.getTelaPermissoesPerfil(this.id, {
          identificadorperfil: this.perfilSelected,
        });

        if(data.results.length > 0) {
          for(const funcao of this.funcoes) {
            funcao.status = data.results.some(key => key.identificadorfuncaotela == funcao.identificadorfuncaotela);
          }
        }
      } finally {
        this.loading = false;
        this.$Progress.finish();
      }
    },
    async onSubmit(funcao) {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        this.loading = true;
        this.$Progress.start();
        this.msgArrayError = [];
        const { data } = await AtenaTelaRepository.postTelaPermissoesPerfil(this.id, {
          identificadorperfil: this.perfilSelected,
          identificadorfuncaotela: funcao.identificadorfuncaotela,
          status: funcao.status,
        });

        this.submitText = data.message;
        this.snackbar = true;
      } catch(error) {
        if (error.response && error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
      } finally {
        this.loading = false;
        this.$Progress.finish();
      }
    },
  },
}
</script>

<style lang="scss">
.permissoes {
  margin: 0px 15px;
}
</style>
